import React from "react";
import { FiSettings } from "react-icons/fi";
import { RxDashboard } from "react-icons/rx";
import { createIconElement } from "utils/iconUtils";

export interface HorizontalMenuType {
  title: string;
  to: string[];
  icon?: React.ReactNode;
  subRoutes?: HorizontalMenuType[];
}

export const horizontalMenus: HorizontalMenuType[] = [
  {
    title: "Dashboard",
    to: ["/", "/dashboard"],
    icon: createIconElement(RxDashboard),
  },
  {
    title: "Configurations",
    to: [
      "/configuration/list",
      "/configuration/add",
      "/configuration/edit/:id",
    ],
    icon: createIconElement(FiSettings),
    subRoutes: [
      {
        title: "Configurations List",
        to: ["/configuration/list"],
      },
      {
        title: "Add Configuration",
        to: ["/configuration/add"],
      },
      {
        title: "Edit Configuration",
        to: ["/configuration/Edit/:id"],
      },
    ],
  },
  // {
  //   title: "Virtual Assistants",
  //   to: [
  //     "/virtualassistant/list",
  //     "/virtualassistant/add",
  //     "/virtualassistant/edit/:id",
  //   ],
  //   icon: React.createElement(FiSettings),
  //   subRoutes: [
  //     {
  //       title: "Virtual Assistants List",
  //       to: ["/virtualassistant/list"],
  //     },
  //     {
  //       title: "Add Virtual Assistant",
  //       to: ["/virtualassistant/add"],
  //     },
  //     {
  //       title: "Edit Virtual Assistant",
  //       to: ["/virtualassistant/Edit/:id"],
  //     },
  //   ],
  // },
];
